import { YoutubeSearchResult } from './youtubeUtilTypes';

export const BLOG_DOMAINS = ['retirein40s', 'jjini'] as const;
export const BLOG_LANGS = [
    'en', // 영어
    'de', // 독일어
    'es', // 스페인어
    'fr', // 프랑스어
    'it', // 이탈리아어
    'nl', // 네덜란드어
    'pt', // 포르투갈어
    'ja', // 일본어
    'ko', // 한국어
] as const;

// 사이트맵 생성 대상 언어
// 언어를 추가할 때 사이트맵에 작업 중인 언어로 생성되지 않게 하기 위함
export const SITEMAP_BLOG_LANGS = BLOG_LANGS;

export type BlogDomainType = (typeof BLOG_DOMAINS)[number];
export type BlogLangType = (typeof BLOG_LANGS)[number];

export type BlogEconomicNewsBodyType = {
    content: string[];
    tickers: string[];
};

export type BlogClassicalMusicBodyType = {
    songTitle: string;
    composer: string;
    player: string;
    content: string[];
    seoDescription: string;
    keywords: string[];
    youtube: YoutubeSearchResult;
};

export const BLOG_LANG_COOKIE_NAME = 'blog_lang' as const;

/**
 * 사용하는 데이터의 일부만 표기
 */
export type UnsplashImage = {
    id: string;
    urls: {
        raw: string;
        full: string;
        regular: string;
        small: string;
        thumb: string;
        small_s3: string;
    };
    links: {
        /**
         * 이미지를 선택했을 때 이 링크로 요청을 보내줘야 함
         * https://help.unsplash.com/en/articles/2511258-guideline-triggering-a-download
         */
        download_location: string;
    };
    user: {
        username: string;
        links: {
            /**
             * 사용자를 클릭하면 이 링크로 이동해줘야 함
             * https://help.unsplash.com/en/articles/2511315-guideline-attribution
             */
            html: string;
        };
    };
};
